<template>
  <div>
    <apexchart
      :width="width"
      type="donut"
      :options="chartOptions"
      :series="series"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
export default {
  components: {
    apexchart: VueApexCharts
  },
  props: {
    labels: {
      type: Array,
      required: true
    },
    series: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      width: "100%",
      chartOptions: {
        chart: {
          width: 380,
          type: "pie"
        },
        legend: {
          position: "bottom"
        },
        tooltip: {
          enabled: true,
          y: {
            formatter(val) {
              return `${new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(val)}`;
            } 
          }
        },
        labels: this.labels
      },
      //series: this.series
    };
  }
};
</script>

<style></style>
